import {
  CenterFocusStrongOutlined as FitViewIcon,
  CloseFullscreenOutlined as CloseFullscreenIcon,
  Fullscreen as FullscreenIcon,
  SvgIconComponent,
  ZoomInOutlined as ZoomInIcon,
  ZoomOutOutlined as ZoomOutIcon,
} from '@mui/icons-material';
import { Box, IconButton, Tooltip } from '@mui/material';
import React from 'react';

interface ControlButtonProps {
  onClick: () => void;
  title: string;
  Icon: SvgIconComponent;
  active?: boolean;
}

const ControlButton: React.FC<ControlButtonProps> = ({ onClick, title, Icon, active }) => {
  return (
    <Tooltip title={title}>
      <IconButton
        onClick={onClick}
        size="small"
        sx={{
          backgroundColor: active ? 'primary.light' : 'transparent',
          '&:hover': { backgroundColor: active ? 'primary.light' : 'action.hover' },
        }}
      >
        <Icon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

interface ZoomControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onFitView: () => void;
  isFitViewToggled: boolean;
  onExpandToggle: () => void;
  isExpanded: boolean;
}

export const ZoomControls: React.FC<ZoomControlsProps> = ({
  onZoomIn,
  onZoomOut,
  onFitView,
  isFitViewToggled,
  onExpandToggle,
  isExpanded,
}) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 10,
        right: 10,
        display: 'flex',
        flexDirection: 'row',
        gap: 1,
        backgroundColor: 'white',
        borderRadius: 2,
        padding: '4px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        zIndex: 1000,
      }}
    >
      <ControlButton onClick={onZoomIn} title="Zoom In" Icon={ZoomInIcon} />
      <ControlButton onClick={onZoomOut} title="Zoom Out" Icon={ZoomOutIcon} />
      <ControlButton
        onClick={onFitView}
        title={isFitViewToggled ? 'Reset View' : 'Fit to View'}
        Icon={FitViewIcon}
        active={isFitViewToggled}
      />
      <ControlButton
        onClick={onExpandToggle}
        title={isExpanded ? 'Exit Fullscreen' : 'Enter Fullscreen'}
        Icon={isExpanded ? CloseFullscreenIcon : FullscreenIcon}
        active={isExpanded}
      />
    </Box>
  );
};
